var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    zoomAndPan: "magnify",
    viewBox: "0 0 24 23.999999",
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "f1335b300a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "84040f54f1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f1335b300a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.4,
    width: 28.8,
    fill: "#000000",
    y: -2.4,
    height: 28.799999,
    fillOpacity: 0.54
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "74b50acbf1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 24,
    y: 0,
    height: 24
  })), /*#__PURE__*/React.createElement("mask", {
    id: "af8fac20f9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f1335b300a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.4,
    width: 28.8,
    fill: "#000000",
    y: -2.4,
    height: 28.799999,
    fillOpacity: 0.54
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "64f2687c1c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 24,
    y: 0,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#84040f54f1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74b50acbf1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 12 0 C 5.382812 0 0 5.382812 0 12 C 0 18.617188 5.382812 24 12 24 C 18.617188 24 24 18.617188 24 12 C 24 5.382812 18.617188 0 12 0 Z M 5.261719 20.039062 C 5.371094 16.414062 8.347656 13.5 12 13.5 C 15.652344 13.5 18.628906 16.414062 18.738281 20.039062 C 16.914062 21.574219 14.5625 22.5 12 22.5 C 9.4375 22.5 7.085938 21.574219 5.261719 20.039062 Z M 8.25 8.25 C 8.25 6.183594 9.933594 4.5 12 4.5 C 14.066406 4.5 15.75 6.183594 15.75 8.25 C 15.75 10.316406 14.066406 12 12 12 C 9.933594 12 8.25 10.316406 8.25 8.25 Z M 20.09375 18.679688 C 19.550781 15.875 17.585938 13.582031 14.980469 12.566406 C 16.351562 11.617188 17.25 10.039062 17.25 8.25 C 17.25 5.355469 14.894531 3 12 3 C 9.105469 3 6.75 5.355469 6.75 8.25 C 6.75 10.039062 7.648438 11.617188 9.019531 12.566406 C 6.414062 13.582031 4.449219 15.875 3.902344 18.679688 C 2.402344 16.863281 1.5 14.535156 1.5 12 C 1.5 6.210938 6.210938 1.5 12 1.5 C 17.789062 1.5 22.5 6.210938 22.5 12 C 22.5 14.535156 21.597656 16.863281 20.09375 18.679688 Z M 20.09375 18.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#af8fac20f9)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#64f2687c1c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 12 0 C 5.382812 0 0 5.382812 0 12 C 0 18.617188 5.382812 24 12 24 C 18.617188 24 24 18.617188 24 12 C 24 5.382812 18.617188 0 12 0 Z M 5.261719 20.039062 C 5.371094 16.414062 8.347656 13.5 12 13.5 C 15.652344 13.5 18.628906 16.414062 18.738281 20.039062 C 16.914062 21.574219 14.5625 22.5 12 22.5 C 9.4375 22.5 7.085938 21.574219 5.261719 20.039062 Z M 8.25 8.25 C 8.25 6.183594 9.933594 4.5 12 4.5 C 14.066406 4.5 15.75 6.183594 15.75 8.25 C 15.75 10.316406 14.066406 12 12 12 C 9.933594 12 8.25 10.316406 8.25 8.25 Z M 20.09375 18.679688 C 19.550781 15.875 17.585938 13.582031 14.980469 12.566406 C 16.351562 11.617188 17.25 10.039062 17.25 8.25 C 17.25 5.355469 14.894531 3 12 3 C 9.105469 3 6.75 5.355469 6.75 8.25 C 6.75 10.039062 7.648438 11.617188 9.019531 12.566406 C 6.414062 13.582031 4.449219 15.875 3.902344 18.679688 C 2.402344 16.863281 1.5 14.535156 1.5 12 C 1.5 6.210938 6.210938 1.5 12 1.5 C 17.789062 1.5 22.5 6.210938 22.5 12 C 22.5 14.535156 21.597656 16.863281 20.09375 18.679688 Z M 20.09375 18.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.739e2253f229ebf85deefd7213671a64.svg";
export { ForwardRef as ReactComponent };